var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2139",
    "data-name": "\\uADF8\\uB8F9 2139",
    transform: "translate(-2041 21994)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_183",
    "data-name": "\\uD0C0\\uC6D0 183",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(2041 -21994)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "free-icon-mail-415166",
    transform: "translate(2053 -21979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2138",
    "data-name": "\\uADF8\\uB8F9 2138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1601",
    "data-name": "\\uD328\\uC2A4 1601",
    d: "M23.874,74.029l-.012-.037-.016-.047-.017-.046-.017-.046-.018-.044-.019-.045-.02-.043-.021-.045-.021-.042-.023-.044-.023-.041-.024-.042-.024-.039-.026-.041-.025-.038-.027-.04-.026-.037-.029-.039-.028-.035-.03-.038-.029-.034-.032-.037-.03-.032L23.3,73.06l-.031-.031L23.24,73l-.032-.03-.036-.033-.033-.028-.037-.031-.034-.027-.038-.03L23,72.79l-.039-.028-.036-.024-.04-.027-.037-.023-.041-.025-.038-.021-.042-.023-.039-.02-.042-.022-.04-.019-.043-.02-.042-.017-.043-.018-.043-.016-.043-.016-.044-.014-.044-.014-.045-.012-.044-.012-.046-.011-.044-.01-.049-.009-.042-.008-.052-.008-.041-.006-.056-.006-.038,0-.062,0-.033,0-.1,0H2.348l-.1,0-.033,0-.062,0-.038,0-.056.006-.041.006-.052.008-.042.008L1.88,72.4l-.044.01-.046.011-.044.012-.045.012-.044.014-.044.014-.044.016-.043.016-.043.018-.042.017-.043.02-.04.019-.042.022-.039.02-.042.023-.038.021-.041.025-.037.023-.04.027-.036.024L1,72.79l-.035.026-.038.03L.9,72.872.861,72.9l-.033.028-.036.033-.032.03-.035.034L.7,73.06.662,73.1l-.03.032L.6,73.165.572,73.2l-.03.038-.028.035-.029.039-.026.037-.027.04-.025.038-.026.041-.024.039-.024.042-.023.041-.023.044-.021.042-.021.045-.02.043-.019.045-.018.044L.171,73.9l-.017.046-.016.047-.012.037A2.342,2.342,0,0,0,0,74.8V87.9a2.41,2.41,0,0,0,2.26,2.452H21.665a2.339,2.339,0,0,0,2.228-1.7.854.854,0,0,0,.027-.118A2.552,2.552,0,0,0,24,87.9V74.8A2.339,2.339,0,0,0,23.874,74.029Zm-22,.131.03-.024.022-.016.031-.02.024-.014.032-.017.025-.012.034-.015.026-.01.036-.012.026-.008L2.193,74,2.218,74l.043-.006.021,0c.022,0,.043,0,.065,0h19.3c.022,0,.044,0,.065,0l.021,0,.043.006.025.005.038.009.026.008.036.012.026.01.034.015.025.012.032.017.024.014.031.02.022.016.03.024.016.013L12.553,84.2a.759.759,0,0,1-1.105,0L1.854,74.173Zm-.3,2.025,4.947,5.172L1.565,86.528V76.185ZM21.652,88.714H2.361a.758.758,0,0,1-.494-.187l5.752-6.013,2.722,2.846a2.276,2.276,0,0,0,3.319,0L16.394,82.5l5.76,6.022A.759.759,0,0,1,21.652,88.714Zm.783-2.213L17.5,81.343l4.934-5.158V86.5Z",
    transform: "translate(0 -72.35)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessage);
export default __webpack_public_path__ + "static/media/ico_message.611f3999f974726e2d72076d9f58b09e.svg";
export { ForwardRef as ReactComponent };